import { assign } from 'xstate'

const setMaxStep = (max, step) => {
  // console.log('currentStep', max, step, ctx.currentStep)
  if(step < max) {
    return max
  }
  return step
}
export default {
  context: {
    maxStep: 1,
    currentStep: 1
  },
  initial: 'fetch_config',
  states: {
    fetch_config: {
      on: {
        STEP_1: 'step_1'
      }
    },
    step_1: {
      entry: [assign({
        currentStep: 1,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 1)
      })],
      on: {
        NEXT: 'validate_step_1'
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_1: {
      invoke: {
        src: 'validateStep1',
        onDone: {
          target: 'step_2'
        },
        onError: {
          target: 'step_1.invalid',
          actions: ['validationError']
        }
      }
    },
    step_2: {
      entry: [assign({
        currentStep: 2,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 2)
      })],
      on: {
        PREV: 'step_1',
        NEXT: 'validate_step_2',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {},
      }
    },
    validate_step_2: {
      invoke: {
        src: 'validateStep2',
        onDone: {
          target: 'step_3'
        },
        onError: {
          target: 'step_2.failure',
          actions: ['validationError']
        }
      }
    },
    step_3: {
      entry: [assign({
        currentStep: 3,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 3)
      })],
      on: {
        PREV: 'step_2',
        NEXT: 'validate_step_3',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_3: {
      invoke: {
        src: 'validateStep3',
        onDone: {
          target: 'step_4'
        },
        onError: {
          target: 'step_3.invalid'
        }
      }
    },
    step_4: {
      entry: [assign({
        currentStep: 4,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 4)
      })],
      on: {
        PREV: 'step_3.valid',
        NEXT: 'validate_step_4',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_4: {
      invoke: {
        src: 'validateStep4',
        onDone: {
          target: 'step_5'
        },
        onError: {
          target: 'step_4.invalid'
        }
      }
    },
    step_5: {
      entry: [assign({
        currentStep: 5,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 5)
      })],
      on: {
        PREV: 'step_4.valid',
        NEXT: 'validate_step_5',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_5: {
      invoke: {
        src: 'validateStep5',
        onDone: {
          target: 'step_6'
        },
        onError: {
          target: 'step_5.invalid'
        }
      }
    },
    step_6: {
      entry: [assign({
        currentStep: 6,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 6)
      })],
      on: {
        PREV: 'step_5.valid',
        NEXT: 'validate_step_6',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_6: {
      invoke: {
        src: 'validateStep6',
        onDone: {
          target: 'step_7'
        },
        onError: {
          target: 'step_6.invalid'
        }
      }
    },
    step_7: {
      entry: [assign({
        currentStep: 7,
        maxStep: (ctx, event) => setMaxStep(ctx.maxStep, 7)
      })],
      on: {
        PREV: 'step_6.valid',
        NEXT: 'validate_step_7',
      },
      initial: 'valid',
      states: {
        valid: {},
        invalid: {},
        failure: {}
      }
    },
    validate_step_7: {
      invoke: {
        src: 'validateStep7',
        onDone: {
          target: 'final'
        },
        onError: {
          target: 'step_7.invalid'
        }
      }
    },
    final: {

    }
  }
}